var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Navigate'),_vm._m(0),_c('Copyright')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/global/logo.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }